// Chuẩn hoá SĐT phía dashboard. Kết quả PHẢI trùng `normalize_phone`
// (crm/bonboz_crm/epoint/reader.py) thì tra cứu khách Epoint mới ra đúng hồ sơ.

// Ký tự phân tách người dùng hay gõ giữa các cụm số.
const PHAN_TACH = /[\s.()-]/g;

// Chỉ nhận chuỗi mở đầu bằng 0, +, hoặc 84 (khách hay copy số dạng 84...).
const DANG_SDT = /^(?:\+|00|0|84)[\d\s.()-]*\d$/;

// Ứng viên trong text: cụm số có thể xen dấu phân tách. Không dùng lookbehind
// vì Safari cũ chưa hỗ trợ — biên trái/phải kiểm tra thủ công bên dưới.
const UNG_VIEN = /\+?\d[\d\s.()-]{5,20}\d/g;

const laKyTuTu = ch => ch !== undefined && /[\w\u00C0-\u1EF9]/.test(ch);

export const chuanHoaSdt = raw => {
  const text = String(raw ?? '').trim();
  if (!DANG_SDT.test(text)) return '';

  let so = text.replace(PHAN_TACH, '').replace(/^\+/, '');

  // '00' cũng là tiền tố quay quốc tế như dấu '+'; phải chốt trước khi cắt.
  const quocTe = text.startsWith('+') || so.startsWith('00');
  if (so.startsWith('00')) so = so.slice(2);

  // 84 + 9/10 số là số Việt Nam viết kiểu quốc tế.
  if (so.startsWith('84') && (so.length === 11 || so.length === 12)) {
    so = `0${so.slice(2)}`;
  }

  // Số Việt Nam: 0 + 9 hoặc 10 chữ số.
  if (/^0\d{9,10}$/.test(so)) return so;

  // Số nước ngoài phải có dấu quốc tế tường minh, tránh nuốt mã đơn hàng.
  if (quocTe && /^\d{8,15}$/.test(so)) return `+${so}`;

  return '';
};

export const timSdtTrongText = text => {
  const chuoi = String(text ?? '');
  const ketQua = [];

  const them = ungVien => {
    const sdt = chuanHoaSdt(ungVien);
    if (sdt && !ketQua.includes(sdt)) ketQua.push(sdt);
    return Boolean(sdt);
  };

  [...chuoi.matchAll(UNG_VIEN)].forEach(m => {
    // Dính chữ hoặc số ở hai đầu => là mã đơn/mã hồ sơ, không phải SĐT.
    const truoc = chuoi[m.index - 1];
    const sau = chuoi[m.index + m[0].length];
    if (laKyTuTu(truoc) || laKyTuTu(sau)) return;

    // Hai số cách nhau đúng một dấu cách bị gộp thành một cụm — tách ra thử lại.
    if (!them(m[0])) m[0].split(/\s+/).forEach(them);
  });

  return ketQua;
};

// Chatwoot bat `phone_number` phai dung E.164 (contact.rb:56), nen luc LUU phai
// doi ve dang `+84...`. Khong doi thi server tra 422 va so khong bao gio vao.
// Hien thi va doi chieu van dung `chuanHoaSdt` (dang `0...`, giong ban CRM).
export const sangE164 = raw => {
  const sdt = chuanHoaSdt(raw);
  if (!sdt) return '';
  return sdt.startsWith('+') ? sdt : `+84${sdt.slice(1)}`;
};

// Dang de NGUOI DOC: so Viet Nam ve dau `0` cho quen mat, so nuoc ngoai giu
// `+` de nhan vien nhin la biet khong phai so trong nuoc. DB van luu E.164 —
// day chi la lop hien thi. Gia tri la khong doc duoc thi tra nguyen, an di
// con te hon hien sai.
export const hienThiSdt = raw => chuanHoaSdt(raw) || String(raw ?? '');
